/**
 * Строка геометки. Место словами, если точка попала в сохранённое место —
 * координаты родителю ничего не говорят, а «рядом: Сад №12» говорит всё.
 *
 * Неточную точку на карту не ставим: пин с ошибкой в километры — прямой путь
 * к ложной тревоге. Радиус показываем словами, чтобы было видно: точка есть,
 * но место по ней не определить.
 *
 * Общая для ленты и карточки смены.
 */

import { formatAccuracy } from '@/features/geo/accuracy'
import type { GeoPoint } from '@/shared/api/day'
import { Icon } from '@/shared/ui/Icon'

export function GeoLine({
  geo,
  label,
  onPress,
}: {
  geo: GeoPoint
  /** Что это за точка, если из контекста не очевидно: «начало смены». */
  label?: string
  onPress?: (geo: GeoPoint) => void
}) {
  const prefix = label ? `${label} — ` : ''

  if (geo.is_approximate) {
    return (
      <p className="text-text-muted mt-1.5 text-caption leading-snug">
        {/* Значок отдельным элементом: в подписи он читался бы скринридером */}
        <Icon name="geo-inaccurate" size={16} className="mr-1 align-[-3px]" />
        {prefix}геометка неточная{geo.accuracy_m ? ` (${formatAccuracy(geo.accuracy_m)})` : ''}
      </p>
    )
  }

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation()
        onPress?.(geo)
      }}
      /* -my-2 гасит паддинг визуально, оставляя зону нажатия не меньше 44px */
      className="text-accent -my-2 mt-1.5 block min-h-[44px] py-3 text-left text-caption font-medium"
    >
      <Icon name="geo-pin" size={16} className="mr-1 align-[-3px]" />
      {prefix}
      {geo.place_title ? `рядом: ${geo.place_title}` : 'показать на карте'}
    </button>
  )
}
